// extracted by mini-css-extract-plugin
export default {"cardwidth":"common_cardwidth__6DwnZ"};